import {helpApiBase} from '..';
import {FaqTopList, RecommendKeyword} from './type';

export const getRecommendKeyword = (): Promise<RecommendKeyword> => {
  return helpApiBase({
    command: 'FaqTopKeyword',
    domainId: 'sooplive',
  }) as Promise<RecommendKeyword>;
};

export const getFaqTopList = (): Promise<FaqTopList> => {
  return helpApiBase({
    command: 'FaqTopList',
    domainId: 'sooplive',
    pageNo: 1,
    rowsPerPage: 8,
  }) as Promise<FaqTopList>;
};
